var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import { consumeContext } from "../../EditorContext";
import ColorPicker from "./ColorPicker";
var fonts = ["times new roman", "arial", "helvetica", "myriad pro", "delicious", "verdana", "georgia", "courier", "comic sans ms", "impact", "monaco", "optima", "plaster", "engagement"];

var Text = function (_React$Component) {
  _inherits(Text, _React$Component);

  function Text() {
    var _temp, _this, _ret;

    _classCallCheck(this, Text);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.makeChangeHandler = function (attribute) {
      var EditorContext = _this.props.EditorContext;
      return function (e) {
        var _extends2;

        EditorContext.setFontSettings(_extends({}, EditorContext.state.fontSettings, (_extends2 = {}, _extends2[attribute] = e.target.value, _extends2)));
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Text.prototype.render = function render() {
    var EditorContext = this.props.EditorContext;
    var _EditorContext$state = EditorContext.state,
        fontSettings = _EditorContext$state.fontSettings,
        availableFonts = _EditorContext$state.availableFonts;
    return React.createElement("div", {
      className: "recorder__gallery font-settings-toolbar"
    }, React.createElement("div", {
      className: "input-container"
    }, React.createElement(ColorPicker, {
      color: fontSettings.fill,
      onChange: function onChange(color) {
        return EditorContext.setFontSettings(_extends({}, EditorContext.state.fontSettings, {
          fill: color
        }));
      }
    })), React.createElement("div", {
      className: "input-container"
    }, React.createElement("label", null, "Font family:"), React.createElement("select", {
      value: fontSettings.fontFamily,
      onChange: this.makeChangeHandler("fontFamily")
    }, (availableFonts || fonts).map(function (font) {
      return React.createElement("option", {
        key: font,
        value: font,
        style: {
          fontFamily: font,
          fontSize: 26
        }
      }, font);
    }))), React.createElement("div", {
      className: "input-container"
    }, React.createElement("label", null, "Font size:"), React.createElement("input", {
      type: "number",
      min: "1",
      max: "120",
      style: {
        margin: "0 10px"
      },
      value: fontSettings.fontSize,
      onChange: this.makeChangeHandler("fontSize")
    }), React.createElement("input", {
      type: "range",
      value: fontSettings.fontSize,
      min: "1",
      max: "120",
      step: "1",
      onChange: this.makeChangeHandler("fontSize")
    })), React.createElement("div", {
      className: "input-container"
    }, React.createElement("label", null, "Line height:"), React.createElement("input", {
      type: "range",
      value: fontSettings.lineHeight,
      min: "0",
      max: "10",
      step: "0.1",
      onChange: this.makeChangeHandler("lineHeight")
    })), React.createElement("div", {
      className: "input-container"
    }, React.createElement("label", null, React.createElement("input", {
      type: "checkbox",
      checked: fontSettings.fontWeight === "bold",
      onChange: function onChange() {
        EditorContext.setFontSettings(_extends({}, fontSettings, {
          fontWeight: fontSettings.fontWeight === "bold" ? "normal" : "bold"
        }));
      }
    }), "Bold"), React.createElement("label", null, React.createElement("input", {
      type: "checkbox",
      checked: fontSettings.fontStyle === "italic",
      onChange: function onChange() {
        EditorContext.setFontSettings(_extends({}, fontSettings, {
          fontStyle: fontSettings.fontStyle === "italic" ? "normal" : "italic"
        }));
      }
    }), "Italic")));
  };

  return Text;
}(React.Component);

Text.propTypes = process.env.NODE_ENV !== "production" ? {
  EditorContext: PropTypes.object.isRequired
} : {};
export default consumeContext(Text);